// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ISetAnswerReactionWebRequest,
  TSetAnswerReactionWebModel,
  IMappers,
  TSetAnswerReactionWebResponse,
  ISetAnswerReactionWebResponse,
  ISetAnswerReactionWebResponseError,
} from './types';

export const defaultConfig: TSetAnswerReactionWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-reviews',
  pathApi: '/v1/set-answer-reaction-web/',
  requestType: 'json',
} as TSetAnswerReactionWebModel;

export function createSetAnswerReactionWebModel(parameters: ISetAnswerReactionWebRequest): TSetAnswerReactionWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISetAnswerReactionWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ISetAnswerReactionWebRequest;
}

export async function fetchSetAnswerReactionWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISetAnswerReactionWebOptions<TResponse200, TResponse400>): Promise<
  TSetAnswerReactionWebResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createSetAnswerReactionWebModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISetAnswerReactionWebResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ISetAnswerReactionWebResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TSetAnswerReactionWebResponse;
}
